import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getReferrerMe } from "../services/referrerService";

const RequireReferrer = () => {
  const [status, setStatus] = useState("checking"); // checking | has-referrer | needs-onboarding

  useEffect(() => {
    getReferrerMe().then((referrer) => {
      setStatus(referrer ? "has-referrer" : "needs-onboarding");
    });
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-bg-base flex items-center justify-center">
        <p className="text-text-muted text-sm">Loading…</p>
      </div>
    );
  }

  if (status === "needs-onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
};

export default RequireReferrer;
